import React, { Component } from 'react';

import sty from 'styled-components';
import Axios from 'axios';
import Campaign from './components/Campaign';

import m from '../../services/media';
export default class AddsScreen extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            name: '',
            url: '',
            mobile: null,
            tablet: null,
            desktop: null,
            campaigns: []
        }
        this.handleImageFile = this.handleImageFile.bind(this);
        this.getAdds = this.getAdds.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.deleteCampaign = this.deleteCampaign.bind(this);
    }
    handleImageFile(e){
        this.setState({
            [e.target.name]: e.target.files
        })
    }
    async getAdds(){
        const data = await Axios.post(
            'https://atibaiatv.rj.r.appspot.com', 
            {
                query: `
                    query {
                        getAdds {
                        id
                        name
                        url
                        images {
                            small {
                                url
                                path
                            }
                            medium {
                                url,
                                path
                            }
                            large {
                                url
                                path
                            }
                        }
                        }
                    }
                `
            },{
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
                
        if(data.status === 200){
            this.setState({
                campaigns: data.data.data.getAdds
            })
        }
    }
    async sendForm(){

        console.log('Send started');
        
        const s = this.state;

        if(s.url){
            if(s.name){
                if(s.mobile || s.tablet || s.desktop){

                    const firebase = this.props.firebase;
                    const storageRef = firebase.storage().ref();
                    
                    const folder = s.name;

                    var mobileUrl = null;
                    var tabletUrl = null;
                    var desktopUrl = null;

                    var mobilePath = null;
                    var tabletPath = null;
                    var desktopPath = null;

                    this.setState({
                        loading: true
                    })

                    if(s.mobile){
                        mobilePath = folder+'/'+s.mobile[0].name;
                        const finalRef = storageRef.child(mobilePath);
                        await finalRef.put(s.mobile[0]);
                        mobileUrl = await finalRef.getDownloadURL();
                    }
                    if(s.tablet){
                        tabletPath = folder+'/'+s.tablet[0].name;
                        const finalRef = storageRef.child(tabletPath);
                        await finalRef.put(s.tablet[0]);
                        tabletUrl = await finalRef.getDownloadURL();
                    }
                    if(s.desktop){
                        desktopPath = folder+'/'+s.desktop[0].name;
                        const finalRef = storageRef.child(desktopPath);
                        await finalRef.put(s.desktop[0]);
                        desktopUrl = await finalRef.getDownloadURL();
                    }

                    const data = await Axios.post(
                        'https://atibaiatv.rj.r.appspot.com', 
                        {
                            query: `
                                mutation createAdd(
                                    $name: String!, 
                                    $url: String!, 
                                    $mobileUrl: String,
                                    $mobilePath: String, 
                                    $tabletUrl: String,
                                    $tabletPath: String,
                                    $desktopUrl: String,
                                    $desktopPath: String
                                ) {
                                    createAdd(input: {
                                        name: $name,
                                        url: $url,
                                        images: {
                                            small: {
                                                url: $mobileUrl,
                                                path: $mobilePath
                                            },
                                            medium: {
                                                url: $tabletUrl,
                                                path: $tabletPath
                                            },
                                            large: {
                                                url: $desktopUrl,
                                                path: $desktopPath
                                            }
                                        }
                                    }){
                                        id
                                    }
                                }
                            `,
                            variables: {
                                name: s.name,
                                url: s.url,
                                mobileUrl: mobileUrl,
                                mobilePath: mobilePath,
                                tabletUrl: tabletUrl,
                                tabletPath: tabletPath,
                                desktopUrl: desktopUrl,
                                desktopPath: desktopPath 
                            }
                        },{
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    console.log(data);
                    
                    if(data.status === 200){
                        this.setState({
                            loading: false,
                            name: '',
                            url: '',
                            mobile: null,
                            tablet: null,
                            desktop: null
                        })
                        this.getAdds();
                    }
                    

                } else {
                    alert('Adicione ao menos uma imagem')
                }
            } else {
                alert('Selecione um nome para a campanha para prosseguir')
            }
        } else {
            alert('Adicone uma url para a campanha');
        }
    }
    async deleteCampaign(campaign){

        const firebase = this.props.firebase;
        const storageRef = firebase.storage().ref();

        if(campaign.images.small.url){
            await storageRef.child(campaign.images.small.path).delete();
        }
        if(campaign.images.medium.url){
            await storageRef.child(campaign.images.medium.path).delete();
        }
        if(campaign.images.large.url){
            await storageRef.child(campaign.images.large.path).delete();
        }        
        const data = await Axios.post(
            'https://atibaiatv.rj.r.appspot.com', 
            {
                query: `
                    mutation deleteAdd($id: String!) {
                        deleteAdd(input: {id: $id}){
                        id
                        }
                    }
                `,
                variables: {
                    id: campaign.id
                }
            },{
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        if(data.status===200){
            this.getAdds()
        }
    }
    componentDidMount(){
        this.getAdds()
    }
    render(){
        const s = this.state;
        return <AddContainer>
            <Header>
                <HeaderText>
                    AtibaiaTV Campanhas
                </HeaderText>
            </Header>
            <Body>
                <Form>
                    <FormHeader>
                        <FormHeaderText>
                            Criar campanha
                        </FormHeaderText>
                        {
                            s.name && s.url && (s.mobile || s.tablet || s.desktop) ? s.loading ? <Send>
                                Carregando
                            </Send> : 
                            <Send onClick={this.sendForm}>
                                Salvar
                            </Send> : null
                        }
                    </FormHeader>
                    <FormBody>
                        <FormSection>
                            <FormSectionHeader>
                                <FormSectionLable>
                                    Nome
                                </FormSectionLable>
                            </FormSectionHeader>
                            <FormSectionBody>
                                <NameInput value={this.state.name} onChange={(e)=>{
                                    this.setState({ name: e.target.value});
                                }}/>
                            </FormSectionBody>
                        </FormSection>
                        <FormSection>
                            <FormSectionHeader>
                                <FormSectionLable>
                                    Link
                                </FormSectionLable>
                            </FormSectionHeader>
                            <FormSectionBody>
                                <LinkInput value={this.state.url} onChange={(e)=>{
                                    this.setState({ url: e.target.value});
                                }}/>
                            </FormSectionBody>
                        </FormSection>
                        <FormSection>
                            <FormSectionHeader>
                                <FormSectionLable>
                                    Mobile 1920x1080
                                </FormSectionLable>
                            </FormSectionHeader>
                            <FormSectionBody>
                                <FileInput onChange={this.handleImageFile} name='mobile' type="file"/>
                            </FormSectionBody>
                        </FormSection>
                        <FormSection>
                            <FormSectionHeader>
                                <FormSectionLable>
                                    Tablet 620x80
                                </FormSectionLable>
                            </FormSectionHeader>
                            <FormSectionBody>
                                <FileInput onChange={this.handleImageFile} name='tablet' type="file"/>
                            </FormSectionBody>
                        </FormSection>
                        <FormSection>
                            <FormSectionHeader>
                                <FormSectionLable>
                                    Desktop 1024x132
                                </FormSectionLable>
                            </FormSectionHeader>
                            <FormSectionBody>
                                <FileInput onChange={this.handleImageFile} name='desktop'  type="file"/>
                            </FormSectionBody>
                        </FormSection>
                    </FormBody>
                </Form>
                <Display>
                    {
                        s.campaigns.map((campaign, index)=><Campaign key={index} {...campaign} delete={this.deleteCampaign}/>)
                    }
                </Display>
            </Body>
        </AddContainer>
    }
}

const AddContainer = sty.div`
    width: 100%;
    flex-direction: column;
`
const Header = sty.div`
    padding: 2rem 0 2rem 2rem;
    flex: 0;
`
const HeaderText = sty.p`
    font-size: 1.75rem
    margin: 0
`
const Body = sty.div`
    flex: 1;
    overflow: hidden;
    padding: 0 2rem 0 2rem;
    ${m.sm`
        flex-direction: column
    `};
    ${m.md`
        flex-direction: row
    `};
    ${m.lg`
        flex-direction: row
    `};
`
const Form = sty.div`
    background-color: #eeeeee;
    border-radius: .5rem;
    margin-right: 1rem;
    padding: 1.5rem;
    flex-direction: column;
    ${m.md`
        align-self: flex-start;
    `};
    ${m.lg`
        align-self: flex-start;
    `};
`
const FormHeader = sty.div`
    margin-bottom: 1rem;
    justify-content: space-between;
`
const FormHeaderText = sty.p`
    margin: 0;
    font-size: 1.25rem;
`
const Send = sty.button`
    font-size: 1rem;
    border-radius: 25px;
    background-color: #1c54f5;
    border: none;
    font-size: .75rem;
    font-weight: bold;
    padding: .5rem 1rem;
    color: white
`
const FormBody = sty.div`
    flex-direction: column;
`
const FormSection = sty.div`
    flex-direction: column;
    margin-bottom: .5rem;
`
const FormSectionHeader = sty.div`
    margin-bottom: .5rem
`
const FormSectionLable = sty.p`
    font-size: 0.75rem;
`
const FormSectionBody = sty.div`
`
const NameInput = sty.input`
    height: 1.5rem;
    border: none;
    border-radius: .25rem;
    box-shadow: 0px 2.5px 10px 0px rgba(170,170,170,.5);
`
const LinkInput = sty.input`
    height: 1.5rem;
    border: none;
    border-radius: .25rem;
    flex: 1;
    box-shadow: 0px 2.5px 10px 0px rgba(170,170,170,.5);
`
const FileInput = sty.input`
`
const Display = sty.div`
    flex: 1;
    overflow: scroll;
    border-radius: .5rem;
    flex-wrap: wrap;
     padding: .5rem 0 0 .5rem;
`

